import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

/***    ANGULAR MATERIAL IMPORT    ***/
// animations
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
// components
import {
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatToolbarModule, MatDatepickerModule, MatFormFieldModule, MatInputModule, MatTableModule, MatSortModule, MatPaginatorModule,
    MatSelectModule, MatDialogModule,
} from '@angular/material';
/***    ANGULAR MATERIAL IMPORT    ***/

// Import app modules
import {SharedModule} from '../SharedModule/shared.module';

// Import module components
import {DashboardComponent} from './DashboardComponent/dashboard.component';
import {EshopHideConfirmDialogComponent} from './DashboardComponent/EshopHideConfirmDialogComponent/eshop-hide-confirm.dialog.component';
import {UserService} from '../services/user.service';
import {FormsModule} from '@angular/forms';
import {MomentModule} from 'angular2-moment';
import {DirectivesModule} from '../directives/directives.module';
import {RouterModule} from '@angular/router';
import {ContractStateComponent} from '../SharedModule/ContractStateComponent/contract-state.component';

@NgModule({
    declarations: [
        DashboardComponent,
        EshopHideConfirmDialogComponent,
    ],
    imports: [
        BrowserModule,
        FormsModule,
        DirectivesModule,
        RouterModule,

        // Angular Material animations
        BrowserAnimationsModule,

        // Angular Material components
        MatButtonModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatMenuModule,
        MatPaginatorModule,
        MatTableModule,
        MatToolbarModule,
        MatSelectModule,
        MatSortModule,
        MatDialogModule,

        // App modules
        SharedModule,
        MomentModule,
    ],
    exports: [
        DashboardComponent
    ],
    entryComponents: [
        EshopHideConfirmDialogComponent,
    ],
    providers: [
    ]
})
export class DashboardModule {
}



// WEBPACK FOOTER //
// /app/src/DashboardModule/dashboard.module.ts